import { PATH } from "src/constants/api-paths";
import { httpReq } from "src/helper/httpReq";
import { DataResponse } from "src/shared/interface/data-response";
import { http } from "./http.services";
import { AxiosError, AxiosResponse } from "axios";
import { messagesError } from "./messages.services";

const Brief = async () => await httpReq(PATH.BRIEF);
const Piramide = async () => await httpReq(PATH.PIRAMIDE);

const getUser = async (user: string): Promise<DataResponse<any[]>> => {
  return http
    .Client(http.Headers.headers)
    .get(`brief/user/${user}`)
    .then((response: AxiosResponse) => {
      return response.data;
    })
    .catch((error: AxiosError) => {
      messagesError(error);
      throw error;
    });
};

export const Api = {
  Brief,
  Piramide,
  getUser
};
